const NAMESPACE = "editEnvelope";

const KEYS = {
    multipleRecipientWarningMessage: "multipleRecipientWarningMessage",
    overviewHeader: "overviewHeader",
    itemsHeader: "itemsHeader",
    itemsAtLeastOneAlert: "itemsAtLeastOneAlert",
    addItemButtonText: "addItemButtonText",
    dragToReorderText: "dragToReorderText",
    recipientsHeader: "recipientsHeader",
    noRecipientsText: "noRecipientsText",
    routingHelpMessage: "routingHelpMessage",
    pleaseCorrectErrorsText: "pleaseCorrectErrorsText",
    enableRoutingLabel: "enableRoutingLabel",
    envelopeNameError: "envelopeNameError",
    attachmentDefinitionError: "attachmentDefinitionError",
    validsignatoryError: "validsignatoryError",
    recipentFieldError: "recipentFieldError",
    editItemTitle: "editItemTitle",
    addItemTitle: "addItemTitle",
    removeItemConfirmation: "removeItemConfirmation",
    removeMessageTitle: "removeMessageTitle",
    removeMessageString: "removeMessageString",
    emailSubjectError: "emailSubjectError",
    firstAndLastNameNotInSameGroupErrorMessage: "firstAndLastNameNotInSameGroupErrorMessage",
    firstAndLastNameNotInContactOrNameGroupErrorMessage: "firstAndLastNameNotInContactOrNameGroupErrorMessage",
    emailNotInSameContactGroupAsFirstAndLastNameErrorMessage:
        "emailNotInSameContactGroupAsFirstAndLastNameErrorMessage",
    fixedEmailMaxLengthValidationMessage: "fixedEmailMaxLengthValidationMessage",
    fixedFullNameMaxLengthValidationMessage: "fixedFullNameMaxLengthValidationMessage"
};

const MESSAGES = {
    [KEYS.multipleRecipientWarningMessage]: {
        value: "If multiple recipients share the same routing order and contact information when the eSignature envelope is requested, but have different private messages, these messages will be merged. The merged message will be limited to {maxNumChars} characters.",
        comment:
            "Warning to show if there is a potential that multiple recipients with private messages will be collapsed into a single signer durign envelope creation."
    },
    [KEYS.overviewHeader]: {
        value: "Overview",
        comment: "Header for the section of the page containing the envelope overview"
    },
    [KEYS.itemsHeader]: {
        value: "Items",
        comment: "Header for the section of the page containing the envelope items"
    },
    [KEYS.itemsAtLeastOneAlert]: {
        value: "Add an item with at least one valid signatory",
        comment: "Alert message if no items have been added"
    },
    [KEYS.addItemButtonText]: {
        value: "Add Item",
        comment: "text label for add item button"
    },
    [KEYS.dragToReorderText]: {
        value: "Drag items to reorder.",
        comment: "Text describing how to reorder envelope items on the UI"
    },
    [KEYS.recipientsHeader]: {
        value: "Recipients",
        comment: "Header for the section of the page with the envelope's recipients"
    },
    [KEYS.noRecipientsText]: {
        value: "This Envelope has no recipients. Add a Document Template Envelope Item with a Signatory Tag to get started.",
        comment: "Text to show if the envelope has no recipients specified"
    },
    [KEYS.routingHelpMessage]: {
        value: "If enabled, you can set the order in which the recipients will be asked to eSign. If disabled, all recipients will be notified simultaneously and may sign in any order.",
        comment: "Message to show if user clicks help icon on the the routing section of the page"
    },
    [KEYS.pleaseCorrectErrorsText]: {
        value: "Please correct the following errors:",
        comment: "Message to show along with list of errors with the envelope configuration"
    },
    [KEYS.enableRoutingLabel]: {
        value: "Enable Routing",
        comment: "Label for the switch to enable/disable routing"
    },
    [KEYS.envelopeNameError]: {
        value: "Envelope Name is required.",
        comment: "Error indicating missing name for envelope"
    },
    [KEYS.attachmentDefinitionError]: {
        value: "Select an Attachment Definition in which to save the completed Envelope.",
        comment: "Error indicating missing attachment definition"
    },
    [KEYS.validsignatoryError]: {
        value: "Add an item with at least one valid signatory.",
        comment: "Error indicating missing an item with a valid signatory on an envelope"
    },
    [KEYS.recipentFieldError]: {
        value: "All recipient fields must be set.",
        comment: "Error indicating missing recipient fields"
    },
    [KEYS.editItemTitle]: {
        value: "Edit Item",
        comment: "Title for Edit Item modal"
    },
    [KEYS.addItemTitle]: {
        value: "Add an Item",
        comment: "Tital for Add Item modal"
    },
    [KEYS.removeItemConfirmation]: {
        value: "Are you sure you want to remove this item?",
        comment: "Comfirmation message for removing an item"
    },
    [KEYS.removeMessageTitle]: {
        value: "Remove {itemRemoved}",
        comment: "Title for the remove item modal"
    },
    [KEYS.removeMessageString]: {
        value: " The following recipients will also be removed: {recipientsRemoved}",
        comment: "Message indicating the following recipients will also be removed"
    },
    [KEYS.emailSubjectError]: {
        value: "Email Subject is required",
        comment: "Error indicating missing Email Subject for envelope"
    },
    [KEYS.firstAndLastNameNotInSameGroupErrorMessage]: {
        value: "First name and last name Contact Info Fields must belong to the same data field group.",
        comment:
            "Error to show if selected first name and last name Contact Info Fields do not belong to the same data field group."
    },
    [KEYS.firstAndLastNameNotInContactOrNameGroupErrorMessage]: {
        value: "First name and last name Contact Info Fields must belong to a contact or name data field group.",
        comment:
            "Error to show if selected First Name or Last Name Contact Info Fields do not belong to a contact or name data field group."
    },
    [KEYS.emailNotInSameContactGroupAsFirstAndLastNameErrorMessage]: {
        value: "Email Contact Info Field must belong to the same contact data field group as first and last name when any Contact Info Field belongs to a contact data field group.",
        comment:
            "Error to show if selected email Contact Info Field doesn't belong to the same contact data field group as first and last name"
    },
    [KEYS.fixedEmailMaxLengthValidationMessage]: {
        value: "Email addresses cannot be more than {maxLength} characters long.",
        comment:
            "Validation message that explains to the user that email addresses for Fixed Recipients can only be up to a certain number of characters long"
    },
    [KEYS.fixedFullNameMaxLengthValidationMessage]: {
        value: "Full name cannot be more than {maxLength} characters long.",
        comment:
            "Validation message that explains to the user that full names for Fixed Recipients can only be up to a certain number of characters long"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
